import { useMediaQuery } from '@mui/material';
import { IClientData, IVehicleData } from '../../createAndEdit/types';
import DetailVehicleAndClientCardsMobile from './mobile/DetailVehicleAndClientCardsMobile';

interface IDetailVehicleAndClientCardsProps {
  vehicleData?: IVehicleData;
  clientData?: IClientData;
}

const DetailVehicleAndClientCards = (props: IDetailVehicleAndClientCardsProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <DetailVehicleAndClientCardsMobile
        vehicleData={props.vehicleData}
        clientData={props.clientData}
      />
    );
  }
  
  return (
    <div className="flex flex-row gap-4 mb-6 px-6 items-stretch">
      {/* Veículo */}
      <div className="flex-1 flex flex-col">
        <div className="mb-2 text-size-13 text-gray-600 dark:text-neutral-300">Veículo</div>
        <div className="border border-gray-200 dark:border-neutral-700 p-2 h-full mr-3 bg-[#E5EBF0] dark:bg-neutral-800">
          <div className="rounded-md h-full" >
            <div className="flex flex-row items-start">
              <div className="bg-white dark:bg-neutral-900 flex items-center justify-center shrink-0 w-[50px] h-[70px] mr-5">
                <img src="/assets/images/truck.svg" alt="Veículo" className="w-12 h-12 dark:invert" />
              </div>
              <div className="flex-1">
                {props.vehicleData && (
                  <div className="text-size-14">
                    {props.vehicleData.model && (
                      <div className="font-semibold text-size-13 text-gray-900 dark:text-neutral-100">
                        {props.vehicleData.model}
                        {props.vehicleData.year && ` ${props.vehicleData.year}`}{' '}
                        {props.vehicleData.licensePlate &&
                          ` | Placa: ${props.vehicleData.licensePlate}`}
                      </div>
                    )}
                    {props.vehicleData.chassis && (
                      <div className="mt-1 text-size-14 text-gray-500 dark:text-neutral-400">Chassi - {props.vehicleData.chassis}</div>
                    )}
                    {(props.vehicleData.odometer || props.vehicleData.hourmeter) && (
                      <div className="mt-1 text-size-14 text-gray-500 dark:text-neutral-400">
                        {props.vehicleData.odometer && `Odômetro: ${props.vehicleData.odometer}`}
                        {props.vehicleData.odometer && props.vehicleData.hourmeter && ' | '}
                        {props.vehicleData.hourmeter && `Horímetro: ${props.vehicleData.hourmeter}`}
                      </div>
                    )}
                    {props.vehicleData.contractNumber && (
                      <div className="mt-1 font-bold">
                        Volks total Prev: Contrato #{props.vehicleData.contractNumber}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {props.vehicleData?.inWarranty && (
                <span className="inline-block bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300 px-3 py-1 rounded-full text-size-12 font-bold whitespace-nowrap mt-1">
                  Em garantia
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Cliente */}
      <div className="flex-1 flex flex-col">
        <div className="mb-2  text-gray-600 dark:text-neutral-300 text-size-13">Cliente</div>
        <div className="border border-gray-200 dark:border-neutral-700 rounded-md p-4 h-full">
          {props.clientData && (
            <div className="text-size-14 h-full">
              {props.clientData.name && (
                <div className="text-size-13 text-gray-900 dark:text-neutral-100 mb-2">{props.clientData.name}</div>
              )}
              <div className="flex flex-row justify-between">
                <div className="text-size-14 text-gray-500 dark:text-neutral-400">{props.clientData.phone || ''}</div>
                <div className="text-right text-size-14 text-gray-500 dark:text-neutral-400">{props.clientData.email || ''}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailVehicleAndClientCards;
